import { useEffect, useRef } from 'react';
import { getIdsForWords, WordId } from 'shared/utils/nlp/get-ids-for-words';

export const useWordIdList = (value: string, masterRegex?: RegExp) => {
  const wordIdList = useRef<WordId[]>();

  useEffect(() => {
    wordIdList.current = getIdsForWords(
      value,
      wordIdList.current ?? [],
      masterRegex,
    );
  }, [value, masterRegex]);

  return wordIdList;
};
